var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRewardsMoney = function SvgRewardsMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M0 0h40v40H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#RewardsMoney_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-121-729h1440v3954H-121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-121-128h1440v482H-121z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#RewardsMoney_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: -32,
    width: 381,
    height: 290,
    rx: 10,
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#03C8B0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "RewardsMoney_svg__c",
    maskUnits: "userSpaceOnUse",
    x: 9.77,
    y: 7,
    width: 20,
    height: 26,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.77 7h20v26h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.59 8a.42.42 0 0 0-.336.23.408.408 0 0 0 .022.403l2.316 3.607a1.55 1.55 0 0 0-.981 1.43c0 .34.117.654.31.911-1.505 1.195-2.756 2.902-3.652 4.678-.943 1.869-1.5 3.8-1.5 5.328 0 4.141 4.183 7.413 9.232 7.413 5.05 0 9.23-3.272 9.23-7.413 0-1.527-.557-3.459-1.5-5.328-.896-1.776-2.145-3.484-3.65-4.678.194-.257.311-.57.311-.911 0-.644-.408-1.198-.981-1.43l2.314-3.607a.408.408 0 0 0 .011-.418.422.422 0 0 0-.365-.215H14.59Zm.803.826h9.214l-2.12 3.298h-4.974l-2.12-3.298Zm1.789 4.126h5.637c.412 0 .733.312.733.718 0 .405-.321.72-.733.72h-5.637a.715.715 0 0 1-.73-.72c0-.406.317-.718.73-.718Zm-.585 2.151c.181.073.378.115.585.115h.888l-1.192 1.854a.41.41 0 0 0 .133.572.428.428 0 0 0 .58-.131l1.393-2.17a.414.414 0 0 0 .055-.125h1.923a.41.41 0 0 0 .055.126l1.395 2.169a.426.426 0 0 0 .59.144.407.407 0 0 0 .123-.585l-1.194-1.854h.887c.207 0 .404-.041.585-.114 1.437 1.092 2.693 2.773 3.577 4.525.898 1.78 1.41 3.635 1.41 4.957 0 3.588-3.706 6.586-8.388 6.586-4.683 0-8.391-2.998-8.391-6.585 0-1.323.516-3.178 1.413-4.958.884-1.752 2.136-3.434 3.573-4.526Zm3.399 3.72a.424.424 0 0 0-.298.125.41.41 0 0 0-.119.296v.886h-.024c-1.008 0-1.817.84-1.817 1.848 0 1.006.809 1.848 1.817 1.848h.894c.536 0 .972.438.972 1.02 0 .582-.436 1.02-.972 1.02h-2.14a.424.424 0 0 0-.303.118.41.41 0 0 0 0 .592c.08.078.19.12.303.118h1.27v.886a.409.409 0 0 0 .12.298.424.424 0 0 0 .602 0 .41.41 0 0 0 .12-.298v-.886h.028c1.008 0 1.814-.841 1.814-1.848 0-1.007-.806-1.848-1.814-1.848h-.894c-.536 0-.975-.438-.975-1.02 0-.583.439-1.02.975-1.02h2.056a.425.425 0 0 0 .303-.118.41.41 0 0 0 0-.592.425.425 0 0 0-.303-.118h-1.19v-.886a.41.41 0 0 0-.122-.299.425.425 0 0 0-.303-.122Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.59 8a.42.42 0 0 0-.336.23.408.408 0 0 0 .022.403l2.316 3.607a1.55 1.55 0 0 0-.981 1.43c0 .34.117.654.31.911-1.505 1.195-2.756 2.902-3.652 4.678-.943 1.869-1.5 3.8-1.5 5.328 0 4.141 4.183 7.413 9.232 7.413 5.05 0 9.23-3.272 9.23-7.413 0-1.527-.557-3.459-1.5-5.328-.896-1.776-2.145-3.484-3.65-4.678.194-.257.311-.57.311-.911 0-.644-.408-1.198-.981-1.43l2.314-3.607a.408.408 0 0 0 .011-.418.422.422 0 0 0-.365-.215H14.59Zm.803.826h9.214l-2.12 3.298h-4.974l-2.12-3.298Zm1.789 4.126h5.637c.412 0 .733.312.733.718 0 .405-.321.72-.733.72h-5.637a.715.715 0 0 1-.73-.72c0-.406.317-.718.73-.718Zm-.585 2.151c.181.073.378.115.585.115h.888l-1.192 1.854a.41.41 0 0 0 .133.572.428.428 0 0 0 .58-.131l1.393-2.17a.414.414 0 0 0 .055-.125h1.923a.41.41 0 0 0 .055.126l1.395 2.169a.426.426 0 0 0 .59.144.407.407 0 0 0 .123-.585l-1.194-1.854h.887c.207 0 .404-.041.585-.114 1.437 1.092 2.693 2.773 3.577 4.525.898 1.78 1.41 3.635 1.41 4.957 0 3.588-3.706 6.586-8.388 6.586-4.683 0-8.391-2.998-8.391-6.585 0-1.323.516-3.178 1.413-4.958.884-1.752 2.136-3.434 3.573-4.526Zm3.399 3.72a.424.424 0 0 0-.298.125.41.41 0 0 0-.119.296v.886h-.024c-1.008 0-1.817.84-1.817 1.848 0 1.006.809 1.848 1.817 1.848h.894c.536 0 .972.438.972 1.02 0 .582-.436 1.02-.972 1.02h-2.14a.424.424 0 0 0-.303.118.41.41 0 0 0 0 .592c.08.078.19.12.303.118h1.27v.886a.409.409 0 0 0 .12.298.424.424 0 0 0 .602 0 .41.41 0 0 0 .12-.298v-.886h.028c1.008 0 1.814-.841 1.814-1.848 0-1.007-.806-1.848-1.814-1.848h-.894c-.536 0-.975-.438-.975-1.02 0-.583.439-1.02.975-1.02h2.056a.425.425 0 0 0 .303-.118.41.41 0 0 0 0-.592.425.425 0 0 0-.303-.118h-1.19v-.886a.41.41 0 0 0-.122-.299.425.425 0 0 0-.303-.122Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.59 8a.42.42 0 0 0-.336.23.408.408 0 0 0 .022.403l2.316 3.607a1.55 1.55 0 0 0-.981 1.43c0 .34.117.654.31.911-1.505 1.195-2.756 2.902-3.652 4.678-.943 1.869-1.5 3.8-1.5 5.328 0 4.141 4.183 7.413 9.232 7.413 5.05 0 9.23-3.272 9.23-7.413 0-1.527-.557-3.459-1.5-5.328-.896-1.776-2.145-3.484-3.65-4.678.194-.257.311-.57.311-.911 0-.644-.408-1.198-.981-1.43l2.314-3.607a.408.408 0 0 0 .011-.418.422.422 0 0 0-.365-.215H14.59Zm.803.826h9.214l-2.12 3.298h-4.974l-2.12-3.298Zm1.789 4.126h5.637c.412 0 .733.312.733.718 0 .405-.321.72-.733.72h-5.637a.715.715 0 0 1-.73-.72c0-.406.317-.718.73-.718Zm-.585 2.151c.181.073.378.115.585.115h.888l-1.192 1.854a.41.41 0 0 0 .133.572.428.428 0 0 0 .58-.131l1.393-2.17a.414.414 0 0 0 .055-.125h1.923a.41.41 0 0 0 .055.126l1.395 2.169a.426.426 0 0 0 .59.144.407.407 0 0 0 .123-.585l-1.194-1.854h.887c.207 0 .404-.041.585-.114 1.437 1.092 2.693 2.773 3.577 4.525.898 1.78 1.41 3.635 1.41 4.957 0 3.588-3.706 6.586-8.388 6.586-4.683 0-8.391-2.998-8.391-6.585 0-1.323.516-3.178 1.413-4.958.884-1.752 2.136-3.434 3.573-4.526Zm3.399 3.72a.424.424 0 0 0-.298.125.41.41 0 0 0-.119.296v.886h-.024c-1.008 0-1.817.84-1.817 1.848 0 1.006.809 1.848 1.817 1.848h.894c.536 0 .972.438.972 1.02 0 .582-.436 1.02-.972 1.02h-2.14a.424.424 0 0 0-.303.118.41.41 0 0 0 0 .592c.08.078.19.12.303.118h1.27v.886a.409.409 0 0 0 .12.298.424.424 0 0 0 .602 0 .41.41 0 0 0 .12-.298v-.886h.028c1.008 0 1.814-.841 1.814-1.848 0-1.007-.806-1.848-1.814-1.848h-.894c-.536 0-.975-.438-.975-1.02 0-.583.439-1.02.975-1.02h2.056a.425.425 0 0 0 .303-.118.41.41 0 0 0 0-.592.425.425 0 0 0-.303-.118h-1.19v-.886a.41.41 0 0 0-.122-.299.425.425 0 0 0-.303-.122Z",
    stroke: "#fff",
    strokeWidth: 0.6,
    mask: "url(#RewardsMoney_svg__c)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -30,
    width: 377,
    height: 286,
    rx: 8,
    stroke: "#03C8B0",
    strokeWidth: 4,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "RewardsMoney_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-121 -729)",
    d: "M0 0h1440v3954H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "RewardsMoney_svg__b",
    x: -32,
    y: -32,
    width: 385,
    height: 294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0117647 0 0 0 0 0.784314 0 0 0 0 0.690196 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13219_804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_13219_804",
    result: "shape"
  })))));
};

export default SvgRewardsMoney;